import React, { useState, useRef, useEffect } from 'react';
import './timeLineChart.css';
import TimelineScrollButton from './timeLineScrollButton';
import TimelineEventDetails from './timeLineEventComponent';

const TimelineChart = ({ timelineEvents }: any) => {
    const [showScrollControls, setShowScrollControls] = useState(false);
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);
    const scrollContainerRef = useRef<HTMLDivElement>(null);

    const checkScrollability = () => {
        if (scrollContainerRef.current) {
            const container = scrollContainerRef.current;
            const isScrollable = container.scrollWidth > container.clientWidth;
            setShowScrollControls(isScrollable);

            if (isScrollable) {
                setCanScrollLeft(container.scrollLeft > 0);
                setCanScrollRight(
                    container.scrollLeft < container.scrollWidth - container.clientWidth
                );
            }
        }
    };

    const scrollLeftRight = (direction: any) => {
        if (direction === 'left') {
            if (scrollContainerRef.current) {
                scrollContainerRef.current.scrollBy({
                    left: -220,
                    behavior: 'smooth'
                });
            }
        } else {
            if (scrollContainerRef.current) {
                scrollContainerRef.current.scrollBy({
                    left: 220,
                    behavior: 'smooth'
                });
            }
        }
    };

    const handleScroll = () => {
        checkScrollability();
    };

    useEffect(() => {
        checkScrollability();
        window.addEventListener('resize', checkScrollability);
        return () => window.removeEventListener('resize', checkScrollability);
    }, []);

    return (
        <>
            <div className='lineCalendarWrapper' >
                <div className='lineCalendarContainer'>
                    {showScrollControls && (
                        <><TimelineScrollButton canScrollLeft={canScrollLeft} canScrollRight={canScrollRight} scrollLeftRight={scrollLeftRight} /></>
                    )}
                    <div ref={scrollContainerRef} onScroll={handleScroll} className='lineCalendarScrollContainer'>
                        {/* Timeline Events Container */}
                        {timelineEvents && timelineEvents.length > 0 && <TimelineEventDetails timelineEvents={timelineEvents} />}
                    </div>
                </div>
            </div>
        </>
    );
};

export default TimelineChart;